module.exports = __webpack_public_path__ + "img/fund-step8-en.17043b8a.png";